export default "__VITE_ASSET__0Tmh5fsM__"